import React, { useCallback, useState } from "react";
import InputGroup from "../../witadmin/CRUD/Common/InputGroup";
import { InputWidgetProps } from "./index";
import CheckboxGroup from "../../witadmin/CRUD/Common/CheckBoxGroup";

export function CheckboxInput({ value, onChange, schema }: InputWidgetProps) {
  const [checked, setChecked] = useState(false);
  const handleChange = useCallback(({ event }) => {
    setChecked(event.target.checked);
  }, []);

  const handleChangeInput = useCallback(
    ({ event }) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <>
      <div className="witadmin-bs3">
        <CheckboxGroup
          value={checked}
          onChange={handleChange}
          field={{ className: "witadmin-bs3", fieldName: `${schema?.title}` }}
        />
      </div>
      {checked && (
        <InputGroup
          type="number"
          value={value}
          field={{ fieldName: `${schema?.title}` }}
          onChange={data => handleChangeInput(data)}
          disabled={false}
          readOnly={false}
        />
      )}
    </>
  );
}
